<div class="ctr">
  <input type="text" id="callingcode" placeholder="Country Code">
  <div id="dropdown">
    <ul>
      <li *ngFor="let c of CallingCodes">{{c.code}} - {{c.country}}</li>
    </ul>
  </div>
</div>
